// ─── Chart series / data colours ────────────────────────────────────────────

/** Main palette used by Bar and Line series charts. */
export const SERIES_COLORS = ['#04438C', '#0570DE', '#06B9EF'];

/** Palette used by Area series charts (fill gradients). */
export const SERIES_COLORS_AREA = ['#0570DE', '#00C078', '#E6AE06'];

/** Palette used by Pie chart slices. */
export const PIE_CHART_COLORS = ['#3b82f6', '#10b981', '#f59e0b'];

/** Named colour stops used for the HeatMap / Scatter intensity gradient (dark end → light end). */
export const HEAT_GRADIENT_COLORS = ['#ecfeff', '#67e8f9', '#3b82f6', '#003366'] as const;

/** RGB colour stops for HeatMap intensity interpolation (used for bubble fill colour gradients). */
export const COLOR_STOPS: Array<[number, number, number]> = [
  [236, 254, 255],
  [103, 232, 249],
  [59, 130, 246],
  [0, 51, 102],
];

/** Named per-category colours for the Scatter chart. */
export const SCATTER_CATEGORY_COLORS: Record<string, string> = {
  high: '#003366',
  medium: '#3b82f6',
  low: '#67e8f9',
};

/** Fallback ordered colours for Scatter categories not in SCATTER_CATEGORY_COLORS. */
export const SCATTER_DEFAULT_COLORS = ['#003366', '#3b82f6', '#67e8f9'];

// ─── Chart structural colours ────────────────────────────────────────────────

/** Colour for CartesianGrid lines in most charts. */
export const CHART_GRID_COLOR = '#f0f0f0';

/** Slightly darker grid colour used by the Scatter chart. */
export const CHART_GRID_COLOR_DARK = '#d1d5db';

/** Fill colour for axis tick labels (used in HeatMap, Area, Scatter). */
export const CHART_TICK_COLOR = '#333333';

/** Fill colour for muted axis tick labels (used in Bar, Line, CustomDateTick). */
export const CHART_TICK_MUTED_COLOR = '#626165';

// ─── Text colours ────────────────────────────────────────────────────────────

/** Primary / heading text colour. */
export const TEXT_PRIMARY = '#111827';

/** Standard body text colour. */
export const TEXT_SECONDARY = '#374151';

/** Muted / secondary text colour. */
export const TEXT_MUTED = '#6b7280';

/** Placeholder / empty-state text colour. */
export const TEXT_PLACEHOLDER = '#9ca3af';

// ─── Surface & border colours ────────────────────────────────────────────────

/** White surface (cards, tooltips, buttons). Use theme.colors.brandLight for design system alignment. */
export const SURFACE_WHITE = '#fff';

/** Hover background for interactive surface elements. */
export const SURFACE_HOVER = '#f9fafb';

/** Subtle panel / header background. */
export const SURFACE_SUBTLE = '#f4f4f5';

/** Thumbnail / image placeholder background. */
export const SURFACE_THUMBNAIL = '#f3f4f6';

/** Default border and tooltip outline colour. Use theme.colors.brandDarkTint90 for design system alignment. */
export const BORDER_DEFAULT = '#e5e7eb';
